import { IStyle } from '@fluentui/react';
import { FontSizes, FontWeights, IH2OTheme } from '@h2oai/ui-kit';

export interface IGPTeInfoCardStyles {
  root?: IStyle;
  header?: IStyle;
  content?: IStyle;
  infoItem?: IStyle;
  label?: IStyle;
  value?: IStyle;
}

export const gpteInfoCardStylesDefault = (theme: IH2OTheme): Partial<IGPTeInfoCardStyles> => ({
  root: {
    width: '100%',
    padding: '1rem',
  },
  header: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  content: {
    display: 'grid',
    gap: '1rem',
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontWeight: FontWeights.semiBold,
    fontSize: FontSizes.small,
    color: theme.palette?.gray500,
  },
  value: {
    fontSize: FontSizes.large,
    color: theme.palette?.gray700,
  },
});
